import {
  Icon,
  IconButton,
  Image,
  Modal,
  ModalContent,
  ModalOverlay,
  VStack,
  useDisclosure,
} from "@chakra-ui/react";
import { Play, X } from "@phosphor-icons/react";
import React from "react";
import VideoPlayer from "./VideoPlayer";
import { Silabus } from "../../const/types";
import useDataChanges from "../../globalState/useDataChanges";
import useTrigger from "../../globalState/useTrigger";

type Props = {
  url: string;
  data: Silabus;
};

export default function VideoPreviewOnTable({ url, data }: Props) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { dataChanges, setDataChanges } = useDataChanges();
  const { trigger, setTrigger } = useTrigger();
  const handleOnClose = () => {
    if (dataChanges) {
      setTrigger(!trigger);
    }
    setDataChanges(null);
    onClose();
  };

  return (
    <>
      <VStack
        borderRadius={8}
        overflow={"clip"}
        w={"100px"}
        h={"50px"}
        position={"relative"}
      >
        <Image
          src={
            data.thumbnail
              ? `${process.env.REACT_APP_MEDIA_BASE_URL}${data.thumbnail}`
              : "/images/thumbnailDefault.png"
          }
        />

        <VStack
          position={"absolute"}
          bg={"blackAlpha.500"}
          w={"100%"}
          h={"100%"}
          justify={"center"}
          p={5}
        >
          <IconButton
            id={`video#${data.id}`}
            aria-label="play button"
            icon={
              <Icon as={Play} weight={"fill"} fontSize={32} color={"white"} />
            }
            className="clicky btn-clear"
            onClick={onOpen}
          />
        </VStack>
      </VStack>

      <Modal isOpen={isOpen} onClose={handleOnClose} isCentered>
        <ModalOverlay />

        <ModalContent w={"100%"} maxW={"1080px"} bg={"transparent"}>
          <VideoPlayer url={url} autoPlay data={data} />

          <IconButton
            mt={4}
            mx={"auto"}
            aria-label="close button"
            icon={<Icon as={X} fontSize={24} />}
            w={"fit-content"}
            className="sm-clicky"
            bg={"white !important"}
            _hover={{ bg: "white !important" }}
            _active={{ bg: "white !important" }}
            color={"black"}
            borderRadius={"full"}
            onClick={handleOnClose}
          />
        </ModalContent>
      </Modal>
    </>
  );
}
